// src/components/ToastContainer.js
import React from 'react';
import { Toast, ToastContainer as RBToastContainer } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { removeToast } from '../redux/actions/authActions';

function Toasts() {
  const dispatch = useDispatch();
  const toasts = useSelector((state) => state.auth.toasts) || [];

  return (
    <RBToastContainer
      className="p-3"
      style={{
        position: 'fixed',
        top: '15%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
      }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          bg={toast.variant || 'dark'}
          onClose={() => dispatch(removeToast(toast.id))}
          delay={7000}
          autohide
        >
          <Toast.Body className="text-light">{toast.message}</Toast.Body>
        </Toast>
      ))}
    </RBToastContainer>
  );
}

export default Toasts;
